import * as React from "react";
import { connect } from "react-redux";
import { IStore } from "reducers";
import { amphibiousGetIn, amphibiousSetIn } from "helpers/objUtils";
import {
    ISingleChoiceEditorProps,
    SingleChoiceCellEditor,
} from "components/product-collection/product-collection-views/product-collection-grid-view/grid-editors/single-choice-cell-editor";

const mapStateToProps = (state: IStore, ownProps: ISingleChoiceEditorProps) => {
    const { statePaths } = ownProps;
    if (statePaths) {
        return {
            stateChunk: statePaths.reduce((acc, path) => {
                amphibiousSetIn(acc, path, amphibiousGetIn(state, path));
                return acc;
            }, {}),
        };
    }
    return {};
};

const PackTypeCellEditorContainer = connect(mapStateToProps, null, null, { withRef: true })(SingleChoiceCellEditor);

export class PackTypeCellEditorEditorWrapper extends React.PureComponent<ISingleChoiceEditorProps> {
    private containerRef;
    constructor(props) {
        super(props);
    }

    attachRef = (element) => {
        if (element) {
            this.containerRef = element?.wrappedInstance;
        }
    };

    getValue() {
        return this.containerRef?.getValue() ?? this.props.value;
    }

    isPopup(): boolean {
        return true;
    }

    render() {
        return <PackTypeCellEditorContainer {...this.props} ref={this.attachRef} />;
    }
}
